var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-48.4%",
    y: "-84.8%",
    width: "196.9%",
    height: "297.2%",
    filterUnits: "objectBoundingBox",
    id: "47qkus8u1b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.6%",
    y: "-20.3%",
    width: "145.2%",
    height: "140.6%",
    filterUnits: "objectBoundingBox",
    id: "uz4zgn3a5d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-134.4%",
    y: "-29.9%",
    width: "383%",
    height: "154%",
    filterUnits: "objectBoundingBox",
    id: "xkorjpmy3f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.129 13.07c0 1.303 1.225 2.36 2.735 2.36 1.511 0 2.736-1.057 2.736-2.36",
    id: "biyul42wia"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.863 0a5.863 5.863 0 0 1 2.732 11.053v1.987H3.132v-1.987A5.863 5.863 0 0 1 5.863 0z",
    id: "wokfcm5f3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.893 8.768v4.526",
    id: "x8mox19ere"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.768 .76)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ECF1FD",
    fillRule: "nonzero",
    cx: 16.201,
    cy: 16.201,
    r: 16.201
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.536 9.03)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#biyul42wia"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#47qkus8u1b)",
    xlinkHref: "#biyul42wia"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#biyul42wia"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.536 9.03)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#wokfcm5f3c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#uz4zgn3a5d)",
    xlinkHref: "#wokfcm5f3c"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#wokfcm5f3c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.536 9.03)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#x8mox19ere"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#xkorjpmy3f)",
    xlinkHref: "#x8mox19ere"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#x8mox19ere"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    d: "m14.423 15.916 2.01 1.873 2.01-1.873"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeOff);
export default __webpack_public_path__ + "static/media/knowledge-off.4ca75e81c977492c0e603fd04bb52785.svg";
export { ForwardRef as ReactComponent };